import { Component, Input, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TypeAdresseCompleteMorale } from '../models/TypeAdresseCompleteMorale';
import { Step5 } from '../../../../shared/models/component-messages/diveAT/step5';

@Component({
  selector: 'app-type-adresse-complete-morale',
  templateUrl: './type-adresse-complete-morale.component.html'
})
export class TypeAdresseCompleteMoraleComponent implements OnInit {

  @Input() uid = '';
  @Input() parentForm: FormGroup;
	@Input() disabled: boolean;
  @Input() titulaire : TypeAdresseCompleteMorale;
  @Input() errorMessagePersonneMoral: string;
  @Input() required: string;
  @Input() rule: String;

  public step5 = new Step5();
  constructor() {
  }

  public ngOnInit() {
  }

  getUid() {
    return this.uid + '_SepSep_TypeAdresseCompleteMorale';
  }
}
